module.exports = __webpack_public_path__ + "static/media/texture_06.a20ca77a.png";